import {
  isFile,
  isFormData,
} from './validator'

export function parseJSON (jsonStr = '') {
  try {
    return JSON.parse(jsonStr)
  } catch (err) {
    return null
  }
}

export function parseClass2String (obj = {}) {
  try {
    const tempStrArr = []

    for (const key in obj) {
      obj[key] && tempStrArr.push(key)
    }

    return tempStrArr.join(' ')
  } catch (err) {
    return ''
  }
}

export function hyphenate (str = '') {
  const hyphenateRE = /([a-z\d])([A-Z])/g

  return str.replace(hyphenateRE, '$1-$2').toLowerCase()
}

export function objectifyBlob (blob) {
  return {
    type: blob.type,
    size: blob.size,
    name: blob.name,
    lastModified: blob.lastModified,
  }
}

export function objectifyFormData (formData) {
  const obj = {}

  formData.forEach((value, key) => {
    switch (true) {
      case isFile(value): {
        value = objectifyBlob(value)

        break
      }
    }
    obj[key] = value
  })

  return obj
}

export function stringifyObject (obj) {
  return JSON.stringify(obj, (key, value) => {
    switch (true) {
      case isFile(value): {
        value = objectifyBlob(value)

        break
      }

      case isFormData(value): {
        value = objectifyFormData(value)

        break
      }
    }

    return value
  })
}
